import script from "./CustomerTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerTable.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerTable.vue?vue&type=style&index=0&id=28ec23ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ec23ba"]])

export default __exports__